"use strict";

exports.__esModule = true;
exports.fetchCommentTableData = exports.CommentTableDataProvider = void 0;
var _last2 = _interopRequireDefault(require("ramda/src/last"));
var _head2 = _interopRequireDefault(require("ramda/src/head"));
var _map2 = _interopRequireDefault(require("ramda/src/map"));
var _uniq2 = _interopRequireDefault(require("ramda/src/uniq"));
var _isEmpty2 = _interopRequireDefault(require("ramda/src/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _Device = require("../../Device");
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _Core = require("../../Core");
var _Time = require("../../Time");
var _Timeline = require("../../Timeline");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var DEFAULT_PAGINATION_OBJECT = {
  number: 0,
  size: 20,
  totalPages: 1,
  numberOfElements: 0,
  sort: []
};

/**
 * Loads logbook comments.
 */
var CommentTableDataProvider = exports.CommentTableDataProvider = function CommentTableDataProvider(props) {
  var columns = props.columns;
  var dataAccessor = _react["default"].useContext(_DataAccessorContext.DataAccessorContext);
  var load = function load(params) {
    return fetchCommentTableData(columns, dataAccessor, params);
  };
  var dataRange = props.dataRange,
    onData = props.onData,
    children = props.children;
  var deviceContext = _react["default"].useContext(_Device.DeviceContext);
  var urlFilter = _react["default"].useContext(_Core.URLFilterContext);
  var reportingPeriod = _react["default"].useContext(_Time.ReportingPeriodContext);
  var selection = _react["default"].useContext(_Core.SelectionContext);
  var devicesList = _react["default"].useContext(_Device.DeviceListContext);
  var devices = (0, _Device.getSelectedDevices)({
    urlFilter: urlFilter,
    deviceContext: deviceContext,
    defaultDeviceList: devicesList,
    selection: selection,
    dataRange: dataRange
  });
  var _getTimePeriod = (0, _Time.getTimePeriod)(reportingPeriod, selection, dataRange),
    interval = _getTimePeriod.interval;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
    load: load,
    params: {
      devices: devices,
      interval: interval,
      columns: columns
    },
    onData: onData
  }, function (_ref) {
    var fetching = _ref.fetching,
      data = _ref.data,
      error = _ref.error,
      reload = _ref.reload;
    return children({
      content: data,
      reload: reload,
      serverPagination: DEFAULT_PAGINATION_OBJECT,
      fetching: fetching,
      error: error
    });
  }));
};
var shouldQueryTimelines = function shouldQueryTimelines(columns, comments) {
  var columnIds = columns.map(function (column) {
    return column.id;
  });
  return !(0, _isEmpty2["default"])(comments) && columnIds.some(function (columnId) {
    return ["state", "activity", "shift", "partKind", "operator", "conditionLevel", "conditionText", "nativeCode"].includes(columnId);
  });
};
var isCommentInInterval = function isCommentInInterval(event, comment) {
  return (comment.createdMillis - event.interval.startMillis) * (comment.createdMillis - event.interval.endMillis) < 0;
};
var getShift = function getShift(timeSeriesData, comment) {
  var _shiftEvent$dimension;
  if (timeSeriesData === void 0) {
    timeSeriesData = [];
  }
  var shiftEvent = timeSeriesData.filter(function (ts) {
    return ts.type === _Timeline.TIME_SERIES_SHIFT;
  }).find(function (event) {
    return isCommentInInterval(event, comment);
  });
  return shiftEvent == null || (_shiftEvent$dimension = shiftEvent.dimensions) == null ? void 0 : _shiftEvent$dimension.shift[0];
};
var getStateAndActivity = function getStateAndActivity(timeSeriesData, comment) {
  var _classifyEvent$dimens;
  if (timeSeriesData === void 0) {
    timeSeriesData = [];
  }
  var classifyEvent = timeSeriesData.filter(function (ts) {
    return ts.type === _Timeline.TIME_SERIES_CLASSIFICATION;
  }).find(function (event) {
    return isCommentInInterval(event, comment);
  });
  return (_classifyEvent$dimens = classifyEvent == null ? void 0 : classifyEvent.dimensions) != null ? _classifyEvent$dimens : {};
};
var getPartKind = function getPartKind(timeSeriesData, comment) {
  var _classifyEvent$dimens2;
  if (timeSeriesData === void 0) {
    timeSeriesData = [];
  }
  var classifyEvent = timeSeriesData.filter(function (ts) {
    return ts.type === _Timeline.TIME_SERIES_KIND;
  }).find(function (event) {
    return isCommentInInterval(event, comment);
  });
  return (_classifyEvent$dimens2 = classifyEvent == null ? void 0 : classifyEvent.dimensions) != null ? _classifyEvent$dimens2 : {};
};
var getOperator = function getOperator(timeSeriesData, comment) {
  var _classifyEvent$dimens3;
  if (timeSeriesData === void 0) {
    timeSeriesData = [];
  }
  var classifyEvent = timeSeriesData.filter(function (ts) {
    return ts.type === _Timeline.TIME_SERIES_OPERATOR;
  }).find(function (event) {
    return isCommentInInterval(event, comment);
  });
  return (_classifyEvent$dimens3 = classifyEvent == null ? void 0 : classifyEvent.dimensions) != null ? _classifyEvent$dimens3 : {};
};
var getConditionLevel = function getConditionLevel(timeSeriesData, comment) {
  var _classifyEvent$dimens4;
  if (timeSeriesData === void 0) {
    timeSeriesData = [];
  }
  var classifyEvent = timeSeriesData.filter(function (ts) {
    return ts.type === _Timeline.TIME_SERIES_CONDITION;
  }).find(function (event) {
    return isCommentInInterval(event, comment);
  });
  return (_classifyEvent$dimens4 = classifyEvent == null ? void 0 : classifyEvent.dimensions) != null ? _classifyEvent$dimens4 : {};
};
var getConditionText = function getConditionText(timeSeriesData, comment) {
  var _classifyEvent$dimens5;
  if (timeSeriesData === void 0) {
    timeSeriesData = [];
  }
  var classifyEvent = timeSeriesData.filter(function (ts) {
    return ts.type === _Timeline.TIME_SERIES_CONDITION;
  }).find(function (event) {
    return isCommentInInterval(event, comment);
  });
  return (_classifyEvent$dimens5 = classifyEvent == null ? void 0 : classifyEvent.dimensions) != null ? _classifyEvent$dimens5 : {};
};
var getNativeCode = function getNativeCode(timeSeriesData, comment) {
  var _classifyEvent$entity;
  if (timeSeriesData === void 0) {
    timeSeriesData = [];
  }
  var classifyEvent = timeSeriesData.filter(function (ts) {
    return ts.type === _Timeline.TIME_SERIES_CONDITION;
  }).find(function (event) {
    return isCommentInInterval(event, comment);
  });
  return (_classifyEvent$entity = classifyEvent == null ? void 0 : classifyEvent.entity) != null ? _classifyEvent$entity : {};
};
var hasColumn = function hasColumn(columnId, columns) {
  var columnIds = columns.map(function (column) {
    return column.id;
  });
  return columnIds.includes(columnId);
};
var getTimeSeriesTypes = function getTimeSeriesTypes(columns) {
  var timelineTypes = new Set([]);
  if (hasColumn("state", columns)) {
    timelineTypes.add(_Timeline.TIME_SERIES_CLASSIFICATION);
  }
  if (hasColumn("activity", columns)) {
    timelineTypes.add(_Timeline.TIME_SERIES_CLASSIFICATION);
  }
  if (hasColumn("shift", columns)) {
    timelineTypes.add(_Timeline.TIME_SERIES_SHIFT);
  }
  if (hasColumn("partKind", columns)) {
    timelineTypes.add(_Timeline.TIME_SERIES_KIND);
  }
  if (hasColumn("operator", columns)) {
    timelineTypes.add(_Timeline.TIME_SERIES_OPERATOR);
  }
  if (hasColumn("conditionLevel", columns)) {
    timelineTypes.add(_Timeline.TIME_SERIES_CONDITION);
  }
  if (hasColumn("conditionText", columns)) {
    timelineTypes.add(_Timeline.TIME_SERIES_CONDITION);
  }
  if (hasColumn("nativeCode", columns)) {
    timelineTypes.add(_Timeline.TIME_SERIES_CONDITION);
  }
  return Array.from(timelineTypes);
};

/**
 * Fetch a list of users from the given API instance.
 */
var fetchCommentTableData = exports.fetchCommentTableData = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(columns, dataAccessor, _ref2) {
    var interval, devices, devicesList, commentsBody, comments, timeSeriesDevices, timeSeriesBody, timeSeries, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          interval = _ref2.interval, devices = _ref2.devices;
          devicesList = devices || [];
          commentsBody = {
            devices: devicesList,
            start: interval ? new Date(interval.startMillis).toISOString() : null,
            end: interval ? new Date(interval.endMillis).toISOString() : null
          };
          _context.p = 1;
          _context.n = 2;
          return dataAccessor.getComments(commentsBody);
        case 2:
          comments = _context.v;
          if (!shouldQueryTimelines(columns, comments)) {
            _context.n = 4;
            break;
          }
          timeSeriesDevices = (0, _uniq2["default"])((0, _map2["default"])(function (comment) {
            return comment.deviceUuid;
          }, comments));
          timeSeriesBody = {
            start: new Date((0, _head2["default"])(comments)["createdMillis"] - 1).toISOString(),
            end: new Date((0, _last2["default"])(comments)["createdMillis"]).toISOString(),
            type: getTimeSeriesTypes(columns),
            entity: {
              device: timeSeriesDevices
            }
          };
          _context.n = 3;
          return dataAccessor.getAdvancedTimeline(timeSeriesBody);
        case 3:
          timeSeries = _context.v;
          return _context.a(2, comments.map(function (comment) {
            var _getStateAndActivity = getStateAndActivity(timeSeries, comment),
              state = _getStateAndActivity.state,
              activity = _getStateAndActivity.activity;
            var _getPartKind = getPartKind(timeSeries, comment),
              part_kind = _getPartKind.part_kind;
            var _getOperator = getOperator(timeSeries, comment),
              operator = _getOperator.operator;
            var _getConditionLevel = getConditionLevel(timeSeries, comment),
              condition_level = _getConditionLevel.condition_level;
            var _getConditionText = getConditionText(timeSeries, comment),
              condition_text = _getConditionText.condition_text;
            var _getNativeCode = getNativeCode(timeSeries, comment),
              native_code = _getNativeCode.native_code;
            var shift = getShift(timeSeries, comment);
            return Object.assign({}, comment, hasColumn("shift", columns) && {
              shift: shift
            }, hasColumn("state", columns) && {
              state: state
            }, hasColumn("activity", columns) && {
              activity: activity
            }, hasColumn("partKind", columns) && {
              partKind: part_kind || undefined
            }, hasColumn("operator", columns) && {
              operator: operator
            }, hasColumn("conditionLevel", columns) && {
              conditionLevel: condition_level
            }, hasColumn("conditionText", columns) && {
              conditionText: condition_text
            }, hasColumn("nativeCode", columns) && {
              nativeCode: native_code || undefined
            });
          }));
        case 4:
          return _context.a(2, comments);
        case 5:
          _context.p = 5;
          _t = _context.v;
          console.error(_t);
        case 6:
          return _context.a(2);
      }
    }, _callee, null, [[1, 5]]);
  }));
  return function fetchCommentTableData(_x, _x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();